import React from 'react';
import { usePortal } from '../../contexts/PortalContext';
import { FileList } from '../../components/FileList';
import { canDownload, clientStatusLabel, fileAction, metaLabel } from '../../utils/deliverables';
import type { FileRow } from '../../types/portal';
export function Files() {
  const {
    finalDeliverables,
    goClient
  } = usePortal();
  const ready = finalDeliverables.filter(item => canDownload(item.status));
  const planned = finalDeliverables.filter(item => !canDownload(item.status));
  const rows: FileRow[] = ready.map(item => {
    // Transcripts open inside Portal, where the client can also correct them.
    if (item.type === 'Transcript') {
      return {
        id: item.id,
        label: item.name,
        meta: metaLabel(item),
        action: 'Open',
        opensInPortal: true
      };
    }
    return {
      id: item.id,
      label: item.name,
      meta: metaLabel(item),
      action: fileAction(item)
    };
  });
  return <div data-id="element-593" data-mp="2r0eq1enbdv3o">
      <h1 className="font-display text-5xl leading-[0.95] tracking-tight sm:text-7xl" data-id="element-594" data-mp="2r050tta3frz1">FILES</h1>
      <p className="mt-8 max-w-xl font-display text-xl text-charcoal" data-id="element-595" data-mp="pn9xymfj637k">
        Final deliverables, delivered through Google Drive.
      </p>

      <div className="mt-16 grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-16" data-id="element-596" data-mp="ko72ntpcrbcs">
        <section aria-label="Final deliverables" className="lg:col-span-8" data-id="element-597" data-mp="fvnsl6pviycq">
          <h2 className="label border-b border-rule pb-4 text-graphite" data-id="element-598" data-mp="aydrgtt4gy92">Final Delivery</h2>
          {rows.length > 0 ? <FileList rows={rows} data-id="element-599" data-mp="5zkgp957zlcl" /> : <div className="border-b border-rule py-10" data-id="element-600" data-mp="1x7bcludxpgc">
              <p className="font-display text-2xl leading-snug text-charcoal" data-id="element-601" data-mp="1vmhkyfwaajj">
                Nothing delivered yet.
              </p>
              <p className="label mt-5 text-mute" data-id="element-602" data-mp="3o4dxrbtpc09y">
                Final files appear here once work is approved and released
              </p>
              <button type="button" onClick={() => goClient('episodes')} className="label mt-8 border border-ink px-6 py-3.5 transition-colors duration-150 ease-out hover:bg-ink hover:text-paper" data-id="element-603" data-mp="1rb2os8a9dm6s">
                Go to Deliverables
              </button>
            </div>}

          {planned.length > 0 && <>
              <h2 className="label mt-16 border-b border-rule pb-4 text-graphite" data-id="element-604" data-mp="36w4q61eipa7r">
                Planned Deliverables
              </h2>
              <ul className="m-0 list-none p-0" data-id="element-605" data-mp="3bs1zvov9zibk">
                {planned.map(item => <li key={item.id} className="flex flex-wrap items-baseline justify-between gap-4 border-b border-rule py-6" data-id="element-606" data-mp="3c9zzfp2rqtr">
                    <span className="min-w-0" data-id="element-607" data-mp="3plb8vofba1tk">
                      <span className="block font-display text-2xl leading-none sm:text-3xl" data-id="element-608" data-mp="3uk4obme5s2wd">
                        {item.name}
                      </span>
                      <span className="label-sm mt-3 block text-mute" data-id="element-609" data-mp="2e8ik8mhththq">{metaLabel(item)}</span>
                    </span>
                    <span className="label shrink-0 text-mute" data-id="element-610" data-mp="117vtqioxpq58">
                      {clientStatusLabel(item.status)}
                    </span>
                  </li>)}
              </ul>
              <p className="label-sm mt-6 leading-relaxed text-mute" data-id="element-611" data-mp="1a8k6la2ldkgj">
                These become available to download once Portal releases them.
              </p>
            </>}
        </section>

        <aside className="lg:col-span-4 lg:border-l lg:border-rule lg:pl-12" data-id="element-612" data-mp="ih4mpnsf6bu0">
          <h2 className="label border-b border-rule pb-4 text-graphite" data-id="element-613" data-mp="if08od0t3wg0">Delivered</h2>
          <ul className="m-0 list-none p-0" data-id="element-614" data-mp="dg6x4q52yfih">
            {ready.length === 0 && <li className="py-6 font-display text-lg text-mute" data-id="element-615" data-mp="rb9d663n5l90">Nothing released yet.</li>}
            {ready.map(item => <li key={item.id} className="border-b border-rule py-6" data-id="element-616" data-mp="3uyjddg7whnhk">
                <p className="font-display text-xl leading-none" data-id="element-617" data-mp="3uwoppu58vh9s">{item.name}</p>
                <p className="label-sm mt-3 text-mute" data-id="element-618" data-mp="3qwoc2bpyza3s">
                  {[item.status, item.versionDate !== '—' ? item.versionDate : ''].filter(Boolean).join(' · ')}
                </p>
              </li>)}
          </ul>
          <p className="label-sm mt-7 leading-relaxed text-mute" data-id="element-619" data-mp="he5wmcev5qyf">
            Reviewing a cut? Requested changes and approvals live under Deliverables. Files holds
            finals only.
          </p>
        </aside>
      </div>
    </div>;
}